import * as types from './index';

export const registerUserAction = (user) => {
  return {
    type: types.REGISTER_USER,
    user
  }
};

export const loginUserAction = (user) => {
  return {
    type: types.LOGIN_USER,
    user
  }
}; 
export const getDSDangChoAction = (data) => {
  return {
    type: types.DATA_DSDANGCHO,
    data
  }
}; 
export const getChiTietCLSAction = (data) => {
  return {
    type: types.DATA_CHITIETCLS,
    data
  }
};

export const saveDataCLSAction = (data) => {
  return {
    type: types.SAVE_DATA,
    data
  }
};
export const getDSHoanTatAction = (data) => {
  return {
    type: types.DATA_DSHOANTAT,
    data
  }
};